<template>
  <div class="create-advert">
    <error :errors="advertsError" />
    <adverts-form action="edit" />
  </div>
</template>

<script>
  import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
  import AdvertsForm from "../../../components/adverts/AdvertsForm";
  import Error from "../../../partials/widgets/Error";
  import { mapGetters } from "vuex";
  export default {
    name: "index",
    components: { AdvertsForm, Error },
    computed: {
      ...mapGetters(['advertsError'])
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: "ئېلان باشقۇرۇش", route: "/adverts/list" },
        { title: "ئۇچۇر تەھرىرلەش" }
      ]);
    },
    data(){
      return {
        formBusy: false,
      };
    },
    methods: {
    }
  }
</script>

<style scoped>

</style>
